import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL || 'http://localhost:5000',
  withCredentials: true,
});

// Set initial Authorization header from localStorage if present
try {
  const token = localStorage.getItem('authToken');
  if (token) {
    axiosInstance.defaults.headers.common['Authorization'] = token;
  }
} catch {}

export default axiosInstance;